export class BreadcrumbStepClass {
	constructor(
		public label: string | null = null,
		public url: string | null = null,
		public callback: (step: BreadcrumbStepClass, index: number) => void | null = null,
	) {}
}
